<template>
	<span>
		<download-hero></download-hero>
		<pazar-training></pazar-training>
		<pazar-files></pazar-files>
		<setup-tools></setup-tools>
		<tablet-tools></tablet-tools>
		<support-tools></support-tools>
		<!-- <pazar-versions /> -->
		<page-footer></page-footer>
	</span>
</template>

<script>
	import DownloadHero from "@/components/DownloadHero";
	import PazarFiles from "@/components/Downloads/PazarFiles";
	import PazarTraining from "@/components/Downloads/PazarTraining";
	import TabletTools from "@/components/Downloads/TabletTools";
	import SetupTools from "@/components/Downloads/SetupTools";
	import SupportTools from "@/components/Downloads/SupportTools";
	import PageFooter from "@/components/PageFooter";
	// import PazarVersions from "@/components/PazarVersions";

	export default {
		name: "download",
		components: {
			DownloadHero,
			PazarFiles,
			PazarTraining,
			TabletTools,
			SetupTools,
			SupportTools,
			// PazarVersions,
			PageFooter,
		},
		// mounted: function () {
		// 	if (this.$store.state.filesLinks.length < 1) {
		// 		this.$store.dispatch("getFilesLinks");
		// 	}
		// },
	};
</script>
